// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","root":"BaseCheckBox_root__DgdIJ","hide":"BaseCheckBox_hide__UQmt3"};